import React from 'react';
import { ArrowLeft, Coins, Filter } from 'lucide-react';
import { type School } from '../../../lib/api';

interface TokenHeaderProps {
  schools: School[];
  selectedSchoolId: number;
  onSchoolChange: (id: number) => void;
  onBack: () => void;
}

const TokenHeader: React.FC<TokenHeaderProps> = ({ 
  schools, 
  selectedSchoolId, 
  onSchoolChange, 
  onBack 
}) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-4">
        <button 
          onClick={onBack} 
          className="p-2 bg-white border rounded shadow-sm hover:bg-gray-100 transition-colors"
        >
          <ArrowLeft size={20} className="text-gray-600" />
        </button>
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Coins className="text-yellow-500" /> Token 财务管理
        </h1>
      </div>
      
      <div className="flex items-center gap-3 bg-white px-4 py-2 rounded-lg border shadow-sm">
         <div className="flex items-center gap-2 text-gray-600 font-medium">
            <Filter size={16} />
            <span>当前机构:</span>
         </div>
         <select 
           value={selectedSchoolId}
           onChange={e => onSchoolChange(Number(e.target.value))}
           className="border p-1 rounded min-w-[200px] outline-none focus:ring-2 focus:ring-blue-500 text-sm"
         >
           {schools.length === 0 && <option value="0">加载中...</option>}
           {schools.map(s => (
             <option key={s.id} value={s.id}>
               {s.schoolname || (s as any).name} (ID: {s.id})
             </option>
           ))}
         </select>
      </div>
    </div>
  );
};

export default TokenHeader;
